import { Box, Card, CircularProgress } from '@mui/material'
import { theme } from 'assets/theme'
import React from 'react'

export const CartLoader = () => {
  return (
    <Card
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        position: 'relative',
        minHeight: '300px',
        border: 'none',
        borderRadius: theme.spacing(2),
        overflow: 'hidden'
      })}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    </Card>
  )
}
